/**
 * The starter questions (agent-1-web W3): fixed copy per screen, sent as the
 * person's own message when tapped. They are questions, not answers -- every
 * word about a reading comes back from the server -- and they say "Report" where
 * the canvas says "Today" (WC1). DRAFT: owner copy review (D3).
 */
import type { MeasureFocus, ScreenRouteName } from './assistantRoute'

const CLEANER = 'How do I get a cleaner recording?'
const USUAL = 'How is “above usual” decided?'

export const STARTERS: Readonly<Record<ScreenRouteName, readonly string[]>> = {
  home: ['What should I do today?', 'What do these cards mean?', CLEANER],
  report: ['What do these rings mean?', USUAL, CLEANER],
  state: ['What does this map show?', USUAL],
  record: [CLEANER, 'How long does a recording take?'],
  'check-in': ['What is the check-in for?'],
  baseline: ["How many days until it's confirmed?", USUAL],
  history: ['What does this list show?'],
  recording: ['What do these cards mean?', USUAL],
  account: ['What happens to my conversations?'],
  assistant: ['What can you help with?', USUAL, CLEANER],
  compare: [],
  experiment: [],
}

/** The three questions about one measure, after "Ask about this". Its title is the card's heading, verbatim. */
export function measureStarters(measure: MeasureFocus): readonly string[] {
  return [`What does “${measure.title}” describe?`, 'How does this compare with my usual?', 'How much can I trust this reading?']
}

/** The two follow-ups under a reply that opened a card. */
export const FOLLOW_UPS: readonly string[] = ['How did this look over the last week?', 'Why this level of evidence?']

/** EXP-011: activity words come from the plan/library payload, verbatim. */
export function comparisonStarters(activityLabel: string | null): readonly string[] {
  return [activityLabel ? `What changed after my ${activityLabel}?` : 'What changed between the two readings?', 'Is one pair enough?']
}

export function comparisonFollowUps(activityLabel: string | null): readonly string[] {
  return [activityLabel ? `Has this happened on my other ${activityLabel}?` : 'Has this happened on my other pairs?', 'Why "beyond" and not "above usual"?']
}
